import { handleActions } from 'redux-actions';
import {
  changeDefaultLanguage,
  changeSearchOption,
  changeSearchValue,
  changeDefaultLanguageCustom,
  setSelectedState,
  setSelectedTag,
} from 'redux/actions/topBarActions';

export const SEARCH_ALL_SITE_OPTION = 1;
export const SEARCH_CLIENT_OPTION = 2;
const defaultState = {
  searchOption: SEARCH_ALL_SITE_OPTION,
  searchValue: '',
  selectedDefaultLanguage: null,
  selectedDefaultLanguageCustom: 'es-ES',
  selectedState: [],
  selectedTag: [],
};

export default handleActions(
  {
    [changeSearchOption](state, action) {
      return { ...state, searchOption: action.payload };
    },
    [changeSearchValue](state, action) {
      return { ...state, searchValue: action.payload };
    },
    [changeDefaultLanguage](state, action) {
      return { ...state, selectedDefaultLanguage: action.payload };
    },
    [changeDefaultLanguageCustom](state, action) {
      return { ...state, selectedDefaultLanguageCustom: action.payload };
    },
    [setSelectedState](state, action) {
      return { ...state, selectedState: action.payload };
    },
    [setSelectedTag](state, action) {
      return { ...state, selectedTag: action.payload };
    },
  },
  defaultState
);
